import { storage } from "@/firebase";

export default {
  namespaced: true,
  state: {
    jsPDF: null,
    font: null
  },
  mutations: {
    setJsPDF(state, jsPDF) {
      state.jsPDF = jsPDF;
    },
    setFont(state, font) {
      state.font = font;
    }
  },
  actions: {
    async loadJsPDF({ state, commit }) {
      if (!state.jsPDF) {
        const jsPDFModule = await import("jspdf");
        commit("setJsPDF", jsPDFModule.default);
      }
    },
    async loadFont({ state, commit }) {
      if (!state.font) {
        const url = await storage
          .ref("fonts/GenYoGothicTW-Regular.json")
          .getDownloadURL();

        const getFont = new Promise(res => {
          const xhr = new XMLHttpRequest();
          xhr.responseType = "json";
          xhr.onload = function() {
            const fontJSON = xhr.response;
            const { encode } = fontJSON;
            commit("setFont", encode);
            res();
          };
          xhr.open("GET", url);
          xhr.send();
        });

        await getFont;
      }
    },
    async createDoc({ state }, fn) {
      const { jsPDF } = state;
      const doc = new jsPDF();
      doc.addFileToVFS("chinese.ttf", state.font);
      doc.addFont("chinese.ttf", "chinese", "normal");
      doc.setFont("chinese", "normal");
      fn(doc);

      const bloburl = doc.output("bloburl");
      window.open(bloburl);
    }
  }
};
